import { Box, Button, Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useDisclosure } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftArrowIcon } from '@assets/icons/index';
import { RoundBadge } from '@components/badge/RoundBadge';
import { ConditionalComponent } from '@components/functionComponent';
import EditOverview from './Overview';
import EditSku from './EditSku';
import EditCustomer from './EditCustomer';
import DeclineModal from './DeclineModal';
import { getButtonConfig } from '@pages/ConsumerPromotion/utils/promotionButtonConfig';
import { usePromotionClaim } from '@pages/ConsumerPromotion/hooks/state/usePromotionClaim';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { useConfirmModal } from '@store/useConfirmModal';
import useGetCPListDetail from '@pages/ConsumerPromotion/hooks/query/useGetCPListDetail';
import useMutateCPList from '@pages/ConsumerPromotion/hooks/mutate/useMutateCPList';
import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePagination';

export default function DetailPromotion() {
    const { id } = useParams();
    const navigate = useNavigate();
    const cookies = new Cookies();
    const role = cookies.get('role');

    const state = usePromotionClaim();
    const stateEdit = useEditDetail();
    const stateConfirm = useConfirmModal();
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [isInvalid, setIsInvalid] = useState(false);
    const { data: dataPagination } = usePaginationStore();

    const { deleteCP, requestApproval, approveRequest, rejectRequest } = useMutateCPList();
    const { data, isLoading } = useGetCPListDetail(id);
    const statusKey = data?.promotion_status?.status?.toLowerCase?.();

    const handleBack = () => {
        navigate(-1);
        state.reset();
    };

    const handleDelete = () => {
        stateConfirm.set({
            isOpen: true,
            title: 'Hapus Promotion Claim?',
            desc: 'Data akan hilang dan harus mengisi ulang.',
            onSubmit: () => {
                deleteCP.mutate(id);
                navigate(-1);
            },
        });
    };

    const config = getButtonConfig({
        role,
        data,
        statusKey,
        onDelete: handleDelete,
        onRequestApproval: () => requestApproval.mutate(id),
        onApprove: () => approveRequest.mutate(id),
        onReject: onOpen,
    });

    const { left = {}, right = {} } = config;

    const handleDecline = () => {
        if (!state.comment) {
            setIsInvalid(true);
            return;
        }
        rejectRequest.mutate({ id, payload: { comment: state.comment } });
        onClose();
    };

    useEffect(() => {
        stateEdit.set({ id, comment: null, isCanEdit: role === 'Area Admin' });
    }, [id, role]);

    useEffect(() => {
        if (data) stateEdit.set({ overviewData: data });
    }, [data]);
    return (
        <>
            <DeclineModal
                isOpen={isOpen}
                onClose={onClose}
                onSubmit={handleDecline}
                value={state.comment}
                onChange={(val) => state.set({ comment: val })}
                isInvalid={isInvalid}
            />

            <Box
                p="16px 24px"
                mb={dataPagination?.length > 0 ? `${250 / dataPagination.length}px` : '0px'}
                bg="semantic.100"
                border="1px solid"
                borderColor="neutral.200"
                borderRadius="8px"
            >
                <Flex justifyContent="space-between" mb="24px" alignItems={'center'}>
                    <Box onClick={handleBack} cursor="pointer">
                        <LeftArrowIcon />
                    </Box>
                    <Box flex={1} ml="12px">
                        <Text fontWeight={700} fontSize={'md'}>
                            Promotion Claim
                        </Text>
                    </Box>

                    <ConditionalComponent statement={role !== 'National Leaders'}>
                        {!left.hide && !isLoading && (
                            <Button
                                variant={left.variant || 'outline'}
                                mr="12px"
                                onClick={left.onClick}
                                disabled={left.disabled}
                            >
                                {left.icon} {left.label}
                            </Button>
                        )}
                        {!right.hide && !isLoading && (
                            <Button
                                variant={right.variant || 'solid'}
                                onClick={right.onClick}
                                disabled={right.disabled}
                            >
                                {right.label}
                            </Button>
                        )}
                    </ConditionalComponent>
                </Flex>

                <EditOverview data={data} isLoading={isLoading} isCanEdit={stateEdit.isCanEdit} />

                <Tabs mt="44px">
                    <TabList>
                        <Tab>Daftar SKU {data?.total_sku === 0 && <RoundBadge ms={2} />}</Tab>
                        <Tab>Daftar Customer {data?.total_customer === 0 && <RoundBadge ms={2} />}</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <EditSku />
                        </TabPanel>
                        <TabPanel>
                            <EditCustomer />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </>
    );
}
